module.exports = __webpack_public_path__ + "static/diagram-80-2@2x-c00ba371d8998d33bec5fe9e973d695c.png";